import { render, staticRenderFns } from "./DataCoverage.vue?vue&type=template&id=5572579a&scoped=true"
import script from "./DataCoverage.vue?vue&type=script&lang=js"
export * from "./DataCoverage.vue?vue&type=script&lang=js"
import style0 from "./DataCoverage.vue?vue&type=style&index=0&id=5572579a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572579a",
  null
  
)

export default component.exports